export const OBTENER_CLIENT = "obtener_clientes";
export const CARGANDO_CLIENT = "cargando clientes";
export const ERROR_CLIENT = "error_clientes";

export const OBTENER_PATIOS = "obtener_patios";
export const CARGANDO_PATIOS = "cargando patios";
export const ERROR_PATIOS = "error_patios";
